/**
 * LA REFERENCE MCP D'UNE FICHE (`docs/socle/fiche-suivi.md`, section 7).
 *
 * Le menu « … » de toute fiche porte « Copier l'ID MCP » : il copie
 * `mytaki://<hote>/<famille>/<id>`, par exemple
 * `mytaki://taki.mytaki.app/todos/3d9e…`. Collee dans Claude, dans Codex ou
 * dans un message a Lia, elle designe UNE fiche d'UN environnement, sans
 * ambiguite : `read_record` l'accepte en `ref`, a la place de `family` et `id`,
 * et refuse une reference d'un autre environnement en nommant l'hote attendu.
 *
 * - `hote` : le domaine de l'app (`window.location.host`), en minuscules, port
 *   compris en local (`localhost:5173`). C'est lui qui dit l'ENVIRONNEMENT.
 * - `famille` : la famille du socle (`todos`, `workOrders`), jamais le nom de
 *   la porte : une porte se renomme, la famille reste.
 * - `id` : l'identifiant du document.
 *
 * RECOPIE COTE SERVEUR dans `functions/src/ia/reference-mcp.ts` (`functions/`
 * ne depend d'aucun `@taki/*`). Le motif tient sur UNE ligne, et
 * `functions/tests/reference-mcp.test.mjs` lit les deux fichiers et echoue si
 * les deux lignes se separent.
 */

/** Le schema d'URL de la reference. */
export const REFERENCE_MCP_SCHEMA = "mytaki";

/** La forme exacte d'une reference : hote (port admis), famille, identifiant. */
export const REFERENCE_MCP_MOTIF = "^mytaki://([a-z0-9](?:[a-z0-9.-]{0,251}[a-z0-9])?(?::[0-9]{1,5})?)/([a-z][A-Za-z0-9]{0,63})/([A-Za-z0-9_-]{1,128})$";

const MOTIF = new RegExp(REFERENCE_MCP_MOTIF);

/** Ce que designe une reference MCP. */
export interface ReferenceMcp {
  hote: string;
  famille: string;
  id: string;
}

/**
 * Fabrique la reference d'une fiche. Leve une erreur sur une piece invalide :
 * une reference que `lireReferenceMcp` ne relirait pas ne doit jamais etre
 * copiee.
 */
export function referenceMcp({ hote, famille, id }: ReferenceMcp): string {
  const texte = `${REFERENCE_MCP_SCHEMA}://${hote.trim().toLowerCase()}/${famille}/${id}`;
  if (!MOTIF.test(texte)) throw new Error(`Référence MCP invalide : ${texte.slice(0, 200)}`);
  return texte;
}

/**
 * Relit une reference collee. Les espaces AUTOUR sont toleres (un copier-coller
 * en ajoute) ; tout le reste est refuse : `null`, jamais une lecture devinee.
 */
export function lireReferenceMcp(texte: unknown): ReferenceMcp | null {
  if (typeof texte !== "string" || texte.length > 600) return null;
  const trouve = MOTIF.exec(texte.trim());
  if (trouve === null) return null;
  return { hote: trouve[1]!, famille: trouve[2]!, id: trouve[3]! };
}
